export interface RuntimeConfig {
  authAuthority: string;
  authClientId: string;
  authClientSecret?: string;
}

const CONFIG_URL = import.meta.env.VITE_CONFIG_URL ?? '/config.json';

export async function getRuntimeConfig(): Promise<RuntimeConfig> {
  try {
    const res = await fetch(CONFIG_URL);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return (await res.json()) as RuntimeConfig;
  } catch {
    return {
      authAuthority: import.meta.env.VITE_AUTH_AUTHORITY ?? '',
      authClientId: import.meta.env.VITE_AUTH_CLIENT_ID ?? '',
      authClientSecret: import.meta.env.VITE_AUTH_CLIENT_SECRET,
    };
  }
}
